
import React from 'react';
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Download, Trash2, Tag } from 'lucide-react';
import { useFeatureBlocking } from '@/hooks/useFeatureBlocking';
import { toast } from 'sonner';

/**
 * Barra de ações em massa para contatos selecionados - ATUALIZADA
 * 
 * Permite executar ações em lote como:
 * - Exportar contatos selecionados
 * - Deletar contatos em massa
 * - Atualizar status/etapa em massa
 * 
 * ONDE É USADO:
 * - ClientsPage quando há contatos selecionados
 * 
 * MUDANÇAS:
 * - UI verde seguindo design system
 * - Container com bordas arredondadas
 * - Hover effects melhorados
 */
interface ClientsActionsBarProps {
  selectedCount: number;
  onExport: () => Promise<void>;
  onDelete: () => Promise<void>;
  onStatusUpdate: (etapaId: string) => Promise<void>;
  isExporting: boolean;
}

export const ClientsActionsBar: React.FC<ClientsActionsBarProps> = ({
  selectedCount,
  onExport,
  onDelete,
  onStatusUpdate,
  isExporting
}) => {
  return (
    <div className="border border-green-200 p-4 bg-green-50 rounded-2xl shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Badge variant="secondary" className="text-green-800 bg-green-100 border-green-200">
            {selectedCount} contatos selecionados
          </Badge>
        </div>
        
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onExport}
            disabled={isExporting}
            className="flex items-center gap-1 rounded-2xl border-green-200 hover:bg-green-50 hover:border-green-300 hover:shadow-md transition-all duration-200"
          >
            <Download className="h-4 w-4" />
            {isExporting ? 'Exportando...' : 'Exportar'}
          </Button>
          
          <Button
            variant="outline"
            size="sm"
            onClick={() => onStatusUpdate('')}
            className="flex items-center gap-1 rounded-2xl border-green-200 hover:bg-green-50 hover:border-green-300 hover:shadow-md transition-all duration-200"
          >
            <Tag className="h-4 w-4" />
            Alterar Status
          </Button>
          
          <Button
            variant="destructive"
            size="sm"
            onClick={onDelete}
            className="flex items-center gap-1 rounded-2xl hover:shadow-md transition-all duration-200"
          >
            <Trash2 className="h-4 w-4" />
            Deletar
          </Button>
        </div>
      </div>
    </div>
  );
};
